import { buildSparsePayload, toOptionalNumber } from "./sparsePayload.js";

// An untouched UI placeholder is not a soil observation; named zero results remain valid.
export function buildFourRAssessmentPayload(fourRAssessmentState) {
  return buildSparsePayload({
    ...fourRAssessmentState,
    crop_year_id: fourRAssessmentState?.crop_year_id,
    soil_tests: (fourRAssessmentState?.soil_tests || []).filter((test) =>
      ["nutrient", "test", "date", "units", "frequency"].some(key => String(test?.[key] ?? "").trim()) ||
      (toOptionalNumber(test?.result) != null && toOptionalNumber(test?.result) !== 0)
    ).map((test) => ({
      ...test,
      result: toOptionalNumber(test?.result) ?? 0,
    })),
    fertilizer_applications: (
      fourRAssessmentState?.fertilizer_applications || []
    ).filter((application) =>
      ["fertilizer_mix_id", "application_date", "application_method", "fertilizer_timing", "soil_state"].some(key => String(application?.[key] ?? "").trim()) ||
      toOptionalNumber(application?.application_rate) != null ||
      (toOptionalNumber(application?.incorporation_depth) ?? 0) !== 0 ||
      application?.has_nitrification_inhibitor != null
    ).map((application) => ({
      ...application,
      incorporation_depth:
        toOptionalNumber(application?.incorporation_depth) ?? 0,
      application_rate: toOptionalNumber(application?.application_rate),
      rate_unit:
        toOptionalNumber(application?.application_rate) == null
          ? undefined
          : application?.rate_unit || "lb/ac",
    })),
  });
}

